module.exports = __webpack_public_path__ + "static/media/SDG8.9f9d14b4.mp4";